import 'Assets/styles/default/pages/focalPoint/FocalPointManagePointsStyles.less';
import { RightOutlined } from '@ant-design/icons';
import { Table, Typography, VertBreadcrumb, VertButton, VertContainer, VertIcon, VertLoading, message } from '@vertem-core/vertice-ds';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import BackArrowIcon from 'components/FocalPoint/Icons/BackArrow';
import { useNavigate, useParams } from 'react-router';
import { Progress } from "antd";
import generateUUID from 'Utils/generateUUID';
import EditIcon from 'components/FocalPoint/Icons/Edit';
import DeleteIcon from 'components/FocalPoint/Icons/Delete';
import { useDispatch, useSelector } from 'react-redux';
import ExcelUploadModal from 'components/FocalPoint/Modals/ExcelUploadModal';
import AddParticipantModal from 'components/FocalPoint/Modals/AddParticipantModal';
import AllocatePointsSuccessModal from 'components/FocalPoint/Modals/AllocatePointsSuccessModal';
import { cpf as cpfFormatter } from 'cpf-cnpj-validator';
import RemoveParticipantModal from 'components/FocalPoint/Modals/RemoveParticipantModal';
import RemoveParticipantSuccessModal from 'components/FocalPoint/Modals/RemoveParticipantSuccessModal';
import EditParticipantModal from 'components/FocalPoint/Modals/EditParticipantModal';
import { pointsMask, pointsMaskToPix } from 'Utils/commons/points';
import { getManagePointsThunk } from 'redux/Reducers/FocalPoint/getManagePointsSlicer';
import { createCreditRequestThunk } from 'redux/Reducers/FocalPoint/createCreditRequestSlicer';
import { resetDataCreateCreditRequest } from 'redux/Reducers/FocalPoint/createCreditRequestSlicer';
import { getParticipantIsFocalPointThunk, resetDataGetParticipantIsFocalPoint } from 'redux/Reducers/FocalPoint/getParticipantIsFocalPointSlicer';
import { formatDocument } from 'Utils/format';

const FocalPointManagePointsPage = () => {

  const [solicitationNumber, setSolicitationNumber] = useState(0);
  const [showModalUploadExcel, setShowModalUploadExcel] = useState(false);
  const [showModalAddParticipant, setShowModalAddParticipant] = useState(false);
  const [showModalEditParticipant, setShowModalEditParticipant] = useState(false);
  const [showModalAllocateSuccess, setShowModalAllocateSuccess] = useState(false);
  const [showModalRemoveParticipant, setShowModalRemoveParticipant] = useState(false);
  const [showModalRemoveParticipantSuccess, setShowModalRemoveParticipantSuccess] = useState(false);
  const [listParticipant, setListParticipant] = useState([]);
  const [participantToEdit, setParticipantToEdit] = useState({});
  const [participantIdDelete, setParticipantIdDelete] = useState("");
  const [distributionAvailable, setDistributionAvailable] = useState({});

  const dispatch = useDispatch();

  const Catalog = useSelector(({ Catalog: data }) => data);
  const { currencyConfiguration: { decimalPlaces, pointsName }, } = Catalog;
  const tableRef = React.useRef();

  const {
    dataGetManagePoints,
    loadingGetManagePoints,
    errorGetManagePoints
  } = useSelector(
    (state) => state.GetManagePoints
  );

  const {
    dataGetParticipantIsFocalPoint,
    loadingGetParticipantIsFocalPoint,
    finishedParticipantIsFocalPoint
  } = useSelector(
    (state) => state.GetParticipantIsFocalPoint
  );

  const {
    dataCreateCreditRequest,
    loadingCreateCreditRequest,
    errorCreateCreditRequest,
  } = useSelector(
    (state) => state.CreateCreditRequest
  );

  const params = useParams();

  const navigate = useNavigate();

  const columns = [
    {
      title: 'Nome do Participante',
      dataIndex: 'name',
      align: 'center'
    },
    {
      title: 'E-mail',
      dataIndex: 'email',
      align: 'center'
    },
    {
      title: 'CPF',
      dataIndex: 'cpf',
      align: 'center',
      render: (_, { cpf }) => (
        <Row justify={'center'}>
          <Col span={24}
          >
            {cpfFormatter.format(cpf)}
          </Col>
        </Row>
      )
    },
    {
      title: `${pointsName.charAt(0).toUpperCase()}${pointsName.slice(1)}`,
      dataIndex: 'points',
      align: 'center',
      render: (_, { points }) => (
        <Row justify={'center'} gutter={[16, 16]}>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={12}
            xl={12}
            xxl={12}
          >
            {pointsWrapper(points)}
          </Col>
        </Row>
      )
    },
    {
      title: 'Ação',
      dataIndex: 'id',
      align: 'center',
      render: (_, { id }) => (
        <Row justify={'center'} gutter={[16, 16]}>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={12}
            xl={12}
            xxl={12}
          >
            <VertButton
              onClick={() => {
                var participantToEdit = listParticipant.find(participant => participant.id == id);
                setParticipantToEdit(participantToEdit);
                setShowModalEditParticipant(true);
              }}
              type="default"
              size="default"
              className='button-historic-redirect button-focal-point button-focal-point-edit'
            >

              <EditIcon />

              <span className='button-focal-point-span'>
                Editar
              </span>

            </VertButton>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={12}
            xl={12}
            xxl={12}
          >
            <VertButton
              type="default"
              size="default"
              className='button-historic-redirect button-focal-point button-focal-point-cancel'
              onClick={() => {
                setShowModalRemoveParticipant(true);
                setParticipantIdDelete(id);
              }}
            >

              <div className='button-focal-point-cancel-container-span'>
                <DeleteIcon />
                <span className='button-focal-point-span'>
                  Excluir
                </span>

              </div>

            </VertButton>
          </Col>
        </Row>
      )
    },

  ];

  const sumTotal = () => {
    return listParticipant.reduce((partial, item) => partial + item.points, 0);
  }

  const remainingPercent = () => {
    return (100 * sumTotal()) / distributionAvailable.balance;
  }

  const remainingPoints = () => {
    if (!distributionAvailable?.balance) {
      return parseFloatPoints(0);
    }
    if (!sumTotal()) {
      return distributionAvailable?.balance;
    }
    if (sumTotal() > distributionAvailable?.balance) {
      return parseFloatPoints(0);
    }
    return parseFloatPoints(pointsMaskToPix(distributionAvailable?.balance - sumTotal(), decimalPlaces, ""));
  }

  const parseFloatPoints = (value) => {
    value = `${value}`.replace(/\./g, '').replace(/\,/g, '.');
    return parseFloat(value);
  }

  const pointsWrapper = (value) => {
    return pointsMask(value, decimalPlaces, pointsName).value;
  }

  const canAllocatePoints = () => {
    return remainingPoints() > 0;
  }

  const addParticipant = (participant) => {

    setListParticipant((prevState) => ([
      ...prevState,
      {
        id: generateUUID(),
        name: participant.name,
        email: participant.email,
        cpf: participant.document,
        points: participant.value,
        participantExists: participant.participantExists
      }
    ]))
    setShowModalAddParticipant(false);
  }

  const handleRemoveParticipant = (id) => {
    var newList = listParticipant?.filter(x => x.id != id);

    setListParticipant(newList);
    setParticipantIdDelete("");
    setShowModalRemoveParticipantSuccess(true);
    setShowModalRemoveParticipant(false);
  }

  const createCreditRequest = (listParticipant) => {
    var request = {
      branchId: distributionAvailable.id,
      walletId: params.id,
      totalValue: distributionAvailable.balance,
      creditName: distributionAvailable.creditName,
      participants: listParticipant.map(participant => ({
        name: participant.name,
        email: participant.email,
        login: participant.cpf,
        value: participant.points
      }))
    }
    dispatch(createCreditRequestThunk(request));
  }

  useEffect(() => {
    if (errorCreateCreditRequest) {
      message.error("Houve um erro na requisição!");
      dispatch(resetDataCreateCreditRequest());
    }
  }, [errorCreateCreditRequest]);

  useEffect(() => {
    if (dataCreateCreditRequest != 0) {
      setSolicitationNumber(dataCreateCreditRequest);
      setShowModalAllocateSuccess(true);
      dispatch(resetDataCreateCreditRequest());
    }
  }, [dataCreateCreditRequest]);

  useEffect(() => {
    if (dataGetManagePoints?.id) {
      setDistributionAvailable(dataGetManagePoints);
    }
  }, [dataGetManagePoints]);

  useEffect(() => {
    if (finishedParticipantIsFocalPoint) {
      if (!dataGetParticipantIsFocalPoint) {
        dispatch(resetDataGetParticipantIsFocalPoint());
        navigate('/home');
        return;
      }
      if (params.id) {
        dispatch(getManagePointsThunk(params.id));
      }
    }
  }, [finishedParticipantIsFocalPoint]);

  useEffect(() => {
    if (!dataGetParticipantIsFocalPoint) {
      dispatch(getParticipantIsFocalPointThunk());
      return;
    }
  }, []);

  return (
    <VertContainer spacingX="regular" spacingY="regular">

      <VertBreadcrumb
        separator={<VertIcon component={RightOutlined} />}
        items={[
          {
            title: 'Início',
            path: '/',
          },
          {
            title: `Gerenciar distribuição de ${pointsName}`,
            path: '/list-manage-points',
          },
          {
            title: `Distribuição de ${pointsName} para participante`,
            path: `/focal-point-manage-points/${params.id}`,
          }
        ]}
      />

      <Row className='container-title-main'>

        <Col xs={24} sm={24} md={20} lg={20} xl={20}>
          <Typography.Text className='manage-points-text-title text-title'>
            Distribuição de {pointsName} para participante
          </Typography.Text>
        </Col>

        <Col xs={24} sm={24} md={4} lg={4} xl={4} className='container-back-button'
          onClick={() => {
            navigate('/list-manage-points');
          }}
        >
          <BackArrowIcon />

          <Typography.Text className='back-button-span'>
            Voltar
          </Typography.Text>
        </Col>
      </Row>

      {
        (loadingGetManagePoints || loadingGetParticipantIsFocalPoint) ?
          <>
            <VertLoading className='loading-space' />
          </>
          :
          <> {
            errorGetManagePoints ?
              <>
                <Typography.Text className='text-title text-not-found'>
                  Houve um erro ao buscar a solicitação
                </Typography.Text>
              </>
              :
              <>
                <Row className='container-title-main' gutter={[16, 16]}>

                  <Col xs={24} sm={24} md={12} lg={16} xl={9}>

                    <Row gutter={[8, 8]}>

                      <Col span={24}>

                        <Typography.Text strong className="manage-points-details-main">
                          {`${pointsName.charAt(0).toUpperCase()}${pointsName.slice(1)}`} disponíveis
                        </Typography.Text>

                      </Col>

                      <Col span={24} className='container-message-allocate-points'>

                        {
                          canAllocatePoints() ?
                            <>
                              {
                                distributionAvailable.distributionExpired ?
                                  <>
                                    <div className='message-allocate-points-expired-chip'>
                                      <Typography.Text className="manage-points-details-sub message-allocate-points-expired-chip-span font-size-max-width">
                                        Distribuição Vencida
                                      </Typography.Text>
                                    </div>
                                  </> :
                                  <div className='message-allocate-points-chip'>
                                    <Typography.Text className="manage-points-details-sub message-allocate-points-chip-span font-size-max-width">
                                      Você tem {pointsWrapper(remainingPoints())} {pointsName} disponíveis para distribuir
                                    </Typography.Text>
                                  </div>
                              }

                            </>
                            :
                            <div className='message-cannot-allocate-points-chip'>
                              <Typography.Text className="manage-points-details-sub message-cannot-allocate-points-chip-span font-size-max-width">
                                Você não possui {pointsName} disponíveis
                              </Typography.Text>
                            </div>
                        }

                      </Col>

                    </Row>

                  </Col>

                  <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                    <Row gutter={[8, 8]}>

                      <Col span={24}>

                        <Typography.Text strong className="manage-points-details-main">
                          Nome do Programa
                        </Typography.Text>

                      </Col>

                      <Col span={24}>

                        <Typography.Text className="manage-points-details-sub">
                          {distributionAvailable.programName}
                        </Typography.Text>

                      </Col>

                    </Row>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={16} xl={5}>
                    <Row gutter={[8, 8]}>

                      <Col span={24}>

                        <Typography.Text strong className="manage-points-details-main">
                          Canal de Distribuição
                        </Typography.Text>

                      </Col>

                      <Col span={24}>

                        <Typography.Text className="manage-points-details-sub">
                          {distributionAvailable.distributionChannel}
                        </Typography.Text>

                      </Col>

                    </Row>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={8} xl={4}>
                    <Row gutter={[8, 8]}>

                      <Col span={24}>

                        <Typography.Text strong className="manage-points-details-main">
                          CNPJ
                        </Typography.Text>

                      </Col>

                      <Col span={24}>

                        <Typography.Text className="manage-points-details-sub">
                          {distributionAvailable.cnpj ? formatDocument(distributionAvailable.cnpj) : <span> - </span>}
                        </Typography.Text>

                      </Col>

                    </Row>
                  </Col>

                </Row>

                <Row justify={'space-between'} className='container-warning-need-allocate'>

                  <Col xs={24} sm={14} md={14} lg={14} xl={14}>

                    <Row gutter={[8, 8]}>

                      <Col span={24}>

                        <Typography.Text strong className="manage-points-details-main">
                          {
                            canAllocatePoints() ?
                              <>
                                Você ainda precisa distribuir
                              </>
                              :
                              <>
                                Nenhum ponto restante para distribuir
                              </>
                          }
                        </Typography.Text>

                      </Col>

                      <Col span={24}>

                        <Typography.Text className='warning-need-allocate-text'>
                          {
                            canAllocatePoints() ?
                              <>
                                Você só conseguirá prosseguir quando todos os {pointsName} forem alocados
                              </>
                              :
                              <>
                                Você já alocou todos os {pointsName} para distribuição
                              </>
                          }
                        </Typography.Text>

                      </Col>

                      <Col span={24}>

                        <Row gutter={[16, 16]} >

                          <Col xs={24} sm={24} md={10} lg={10} xl={10} className='container-allocate-points-progress'>

                            <Progress className={`${canAllocatePoints() ? 'progress-remaining-points-finished' : 'progress-remaining-points'}  `} percent={remainingPercent()} status="active" showInfo={false} />

                            <span className='allocate-points-progress-span'>
                              {pointsWrapper(distributionAvailable.balance)}
                            </span>

                          </Col>

                          <Col>
                            {
                              canAllocatePoints() ?
                                <>
                                  <VertButton
                                    disabled
                                    type="highlight"
                                    size="default"
                                    className='button-historic-redirect button-focal-point'
                                  >
                                    Distribuir {pointsName}
                                  </VertButton>
                                </>
                                :
                                <>
                                  <VertButton
                                    loading={loadingCreateCreditRequest}
                                    onClick={() =>
                                      createCreditRequest(listParticipant)
                                    }
                                    type="highlight"
                                    size="default"
                                    className='button-historic-redirect button-focal-point'
                                    disabled={distributionAvailable.distributionExpired}
                                  >
                                    Finalizar distribuição
                                  </VertButton>
                                </>
                            }

                          </Col>

                        </Row>

                      </Col>

                    </Row>

                  </Col>

                  <Col xs={24} sm={10} md={10} lg={10} xl={10} className='margin-top-spacing'>

                    <Row gutter={[24, 24]} justify={'end'} className='justify-max-width'>

                      <Col>
                        <VertButton
                          onClick={() => setShowModalUploadExcel(!showModalUploadExcel)}
                          type="default"
                          size="default"
                          className='button-historic-redirect button-focal-point'
                          disabled={distributionAvailable.distributionExpired || !canAllocatePoints()}
                        >
                          Importar CSV
                        </VertButton>
                      </Col>

                      <Col>
                        <VertButton
                          type="highlight"
                          size="default"
                          className='button-historic-redirect button-focal-point'
                          onClick={() => { setShowModalAddParticipant(true) }}
                          disabled={distributionAvailable.distributionExpired || !canAllocatePoints()}
                        >
                          Adicionar participante
                        </VertButton>
                      </Col>

                    </Row>

                  </Col>

                </Row>

                <div ref={tableRef} />

                {
                  listParticipant.length > 0 &&
                  <Row className='container-table-allocate-points-participant'>

                    <Col span={24}>
                      <Table
                        className='table-focal-point'
                        bordered
                        columns={columns}
                        dataSource={listParticipant}
                        pagination={{
                          showSizeChanger: false,
                          pageSize: 10,
                          total: listParticipant.length,
                          position: ['bottomCenter']
                        }}
                      />
                    </Col>

                  </Row>
                }
              </>
          }

          </>
      }

      <ExcelUploadModal
        remainingPoints={remainingPoints()}
        isOpen={showModalUploadExcel}
        onClose={() => setShowModalUploadExcel(false)}
        finishUpload={res => {
          setListParticipant((prevState) => ([
            ...prevState,
            ...res?.listParticipant
          ]))
          setShowModalUploadExcel(false);
          if (res?.save) {
            createCreditRequest(
              [
                ...res?.listParticipant,
                ...listParticipant
              ]
            );
          }
          else {
            setTimeout(() => {
              tableRef?.current?.scrollIntoView({ behavior: 'smooth' });
            }, 1000);
          }
        }}
        listDocument={listParticipant.map(a => ({
          cpf: a.cpf
        }))}
        decimalPlaces={decimalPlaces}
        pointsName={pointsName}
        balance={remainingPoints()}
      />

      <AddParticipantModal
        isOpen={showModalAddParticipant}
        addParticipant={participant => {
          addParticipant(participant)
        }}
        onClose={() => setShowModalAddParticipant(false)}
        remainingPoints={remainingPoints()}
        pointsName={pointsName}
        decimalPlaces={decimalPlaces}
        listDocument={listParticipant.map(a => ({
          cpf: a.cpf
        }))}
      />

      <EditParticipantModal
        participantToEdit={participantToEdit}
        listDocument={listParticipant.filter(a => a.cpf != participantToEdit.cpf).map(a => ({
          cpf: a.cpf
        }))}
        isOpen={showModalEditParticipant}
        editParticipant={participant => {

          var previousList = [...listParticipant];
          var participantEdited = previousList.find(b => b.id == participant.id);

          participantEdited.name = participant.name;
          participantEdited.email = participant.email;
          participantEdited.cpf = participant.document;
          participantEdited.points = participant.value;
          participantEdited.participantExists = participant.participantExists;

          setListParticipant(previousList);
          setShowModalEditParticipant(false);
          setParticipantToEdit({});
        }}
        onClose={() => {
          setShowModalEditParticipant(false);
          setParticipantToEdit({});
        }}
        remainingPoints={remainingPoints()}
        pointsName={pointsName}
        decimalPlaces={decimalPlaces}
      />

      <AllocatePointsSuccessModal
        solicitationNumber={solicitationNumber}
        isOpen={showModalAllocateSuccess}
        onClose={() => {
          setShowModalAllocateSuccess(false);
          setSolicitationNumber(0);
          navigate(`/list-manage-points`);
        }}
      />

      <RemoveParticipantModal
        isOpen={showModalRemoveParticipant}
        onClose={() => setShowModalRemoveParticipant(false)}
        onRemove={id => { handleRemoveParticipant(id) }}
        id={participantIdDelete}
      />

      <RemoveParticipantSuccessModal
        isOpen={showModalRemoveParticipantSuccess}
        onClose={() => { setShowModalRemoveParticipantSuccess(false) }}
      />

    </VertContainer >
  )
};

export default FocalPointManagePointsPage;
